import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

async function mount() {
  const wantsPreview =
    import.meta.env.DEV && new URLSearchParams(window.location.search).has("preview");
  const preview = wantsPreview ? await import("./preview") : null;
  createRoot(document.getElementById("root") as HTMLElement).render(
    <StrictMode>
      <App {...(preview ? { previewData: preview.previewData } : {})} />
    </StrictMode>,
  );
}

void mount();

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}
